import * as React from 'react';
import ReportOutlined from './report-outlined';
import ReportFilled from './report-filled';
import type { IconCombinedProps } from './types';
const ReportCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ReportFilled ref={ref} {...rest} />;
  }
  return <ReportOutlined ref={ref} {...rest} />;
});
export default ReportCombined;